import { render, staticRenderFns } from "./FireClaimPosted.vue?vue&type=template&id=59cadf95&"
import script from "./FireClaimPosted.vue?vue&type=script&lang=js&"
export * from "./FireClaimPosted.vue?vue&type=script&lang=js&"
import style0 from "./FireClaimPosted.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FireClaimPosted.vue"
export default component.exports